import type { PaymentCreate, PaymentMethodOut, PaymentOut } from "@shop-ledger/shared-types";
import { apiRequest } from "../lib/apiClient";

export async function listPaymentMethods(accessToken: string): Promise<PaymentMethodOut[]> {
  return apiRequest<PaymentMethodOut[]>("/payments/methods", { accessToken });
}

/** `POST /payments` — records a payment against exactly one of a sale or an
 * invoice/bill. */
export async function recordPayment(accessToken: string, body: PaymentCreate): Promise<PaymentOut> {
  return apiRequest<PaymentOut>("/payments", { method: "POST", accessToken, body });
}

export interface ListPaymentsQuery {
  saleId?: string;
  invoiceOrBillId?: string;
  statusFilter?: string;
}

/** `GET /payments` — known gap, now fixed (§10.5/§10.6 of the backend doc): a real
 * itemized payment list, filterable by `sale_id`/`invoice_or_bill_id`/`status_filter`.
 * `PaymentsPage` uses this instead of the previous denormalized-invoice-aggregate
 * stand-in. */
export async function listPayments(accessToken: string, query: ListPaymentsQuery = {}): Promise<PaymentOut[]> {
  return apiRequest<PaymentOut[]>("/payments", {
    accessToken,
    query: { sale_id: query.saleId, invoice_or_bill_id: query.invoiceOrBillId, status_filter: query.statusFilter },
  });
}
